import React, { memo } from "react";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

// constants
import { TEXTS } from "@payment-ui/constants";

//styles
import styles from "../styles.scss";
import cx from "classnames";

// test-ids
import { UPI_INTENT_TEST_IDS, UPI_TIMER_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface UPICancelProps {
    onCancel: (e: React.MouseEvent) => void;
    isIntent?: boolean;
}

function UPICancelButton({ onCancel, isIntent = false }: UPICancelProps) {
    const TEST_ID = isIntent ? UPI_INTENT_TEST_IDS : UPI_TIMER_TEST_IDS;

    const className = cx({
        [styles.containerActionIntent]: isIntent,
    });

    return (
        <TextButton
            className={className}
            buttonSize="medium"
            color="primary"
            onClick={onCancel}
            data-testid={TEST_ID.CANCEL_PAYMENT_LINK}
        >
            {TEXTS.CANCEL_PAYMENT}
        </TextButton>
    );
}

export default memo(UPICancelButton);
